export enum VideoResolution {
  P240 = 1, // (SD): 426x240
  P360 = 2, // (SD): 640x360
  P480 = 3, // (SD): 854x480
  P720 = 4, // (HD): 1280x720
  P1080 = 5, // (HD): 1920x1080
}

export const getVideoResolutionName = (resolution: VideoResolution) => {
  switch (resolution) {
    case VideoResolution.P240:
      return "240p";
    case VideoResolution.P360:
      return "360p";
    case VideoResolution.P480:
      return "480p";
    case VideoResolution.P720:
      return "720p";
    case VideoResolution.P1080:
      return "1080p";
    default:
      return "Unknown";
  }
};

export const getVideoResolutionOption = () => {
  return [
    {
      label: getVideoResolutionName(VideoResolution.P240),
      value: VideoResolution.P240,
    },
    {
      label: getVideoResolutionName(VideoResolution.P360),
      value: VideoResolution.P360,
    },
    {
      label: getVideoResolutionName(VideoResolution.P480),
      value: VideoResolution.P480,
    },
    {
      label: getVideoResolutionName(VideoResolution.P720),
      value: VideoResolution.P720,
    },
    {
      label: getVideoResolutionName(VideoResolution.P1080),
      value: VideoResolution.P1080,
    },
  ];
};
